/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { BiLoaderAlt } from "react-icons/bi";
import { FaArrowRight } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import Sorting from "../../../Common/Sorting";
import MetaHead from "../../../Common/Metahead";
import { sortingAPIList } from "../../../../utilities/enums";
import Search from "../../../Common/Search";
import { connect } from "react-redux";
import Paginations from "../../../Common/Pagination";
import { campaignList } from "../../../../stores/actions/campaign.actions.types";
import CampaignTable from "../../../Tables/CampaignTable";
import AddEmailCampaign from "../../../Modals/add-email-campaign";
import { Link } from "react-router-dom";

const PendingEmailCampaignPage = ({ campaignList }) => {
  const { t } = useTranslation();

  const [pagination, setPagination] = useState({ page: 1, total: 0 });
  const [campaigns, setCampaigns] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [recepientCount, setRecepientCount] = useState({});
  const [reload, setReload] = useState(false);
  const [sorting, setSorting] = useState([
    {
      whom: "updatedAt",
      order: "desc",
    },
  ]);

  useEffect(() => {
    setLoading(true);
    getCampaigns(pagination.page, sorting, search);
  }, [sorting, pagination.page, search, reload]);

  const getCampaigns = (page, sort, search) => {
    const callback = (data) => {
      if (data.success) {
        const { total, pages, campaigns, recepientCount } = data?.data;

        setPagination((prev) => ({
          ...prev,
          total: total || 0,
          pages: pages || 1,
        }));

        setCampaigns(campaigns);
        setRecepientCount(recepientCount);
        setLoading(false);
      } else {
        setLoading(false);
      }
    };

    let request = {
      callback,
      data: { type: "pending-email", page, sort, q: search },
    };
    campaignList(request);
  };

  const handleChangeSorting = (value) => {
    const sort = JSON.parse(value);
    setSorting([sort]);
  };

  return (
    <div>
      <MetaHead title={t("email-campaign-list")} />
      <div className=' rounded dark:bg-boxdark bg-white min-h-52 p-10'>
        <h2 className='flex items-center justify-center gap-2'>
          Create email template <FaArrowRight />
          Create campaign <FaArrowRight /> Send Email
        </h2>
        <div className='flex w-6/12 gap-10 mt-10 m-auto justify-center items-center'>
          <AddEmailCampaign
            type={"pending-email"}
            setReload={setReload}
            reload={reload}
          />
          <Link
            to={"/settings/email-templates"}
            className='mt-4 block w-[200px] rounded-md bg-red-600 px-4 py-2 text-white'
          >
            Create Email Template
          </Link>
        </div>
      </div>

      <div className='flex mt-10 mb-3 w-full justify-between'>
        {loading ? (
          <div></div>
        ) : (
          <div className='flex items-center gap-2'>
            <div className='border dark:border-gray-300 border-gray-800 rounded-full px-4 py-1 text-sm '>
              <h2>Total Pending Orders ({recepientCount?.pendingOrders})</h2>
            </div>
          </div>
        )}

        <div className='flex flex-col sm:flex-row justify-end  gap-2'>
          <Search
            placeholder='Campaign Name'
            search={search}
            setSearch={setSearch}
          />
          <Sorting
            name={"Sort"}
            values={sortingAPIList}
            onChange={handleChangeSorting}
          />
        </div>
      </div>

      {loading ? (
        <div className='flex rounded dark:bg-boxdark bg-white items-center justify-center min-h-96'>
          <BiLoaderAlt className='animate-spin text-4xl text-primary dark:text-white' />
        </div>
      ) : campaigns?.length ? (
        <div>
          <CampaignTable
            campaigns={campaigns}
            setCampaigns={setCampaigns}
            reload={reload}
            setReload={setReload}
          />
          <Paginations pagination={pagination} setPagination={setPagination} />
        </div>
      ) : (
        <div className='flex rounded dark:bg-boxdark bg-white items-center justify-center min-h-96'>
          Not found
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  loading: state.app.visible,
});

export default connect(mapStateToProps, {
  campaignList,
})(PendingEmailCampaignPage);
